import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaShoppingCart, FaMoneyBillWave, FaHandHoldingUsd, FaUser } from "react-icons/fa";
import AspirasiBerandaSkeleton from "../../../Components/loading/skeletonBeranda";

const BerandaAffiliateSummary = () => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const fetchSummary = async () => {
    try {
      const token = document.cookie
        .split("; ")
        .find((row) => row.startsWith("token="))
        ?.split("=")[1];

      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/affiliate/my-sales`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      setData(res.data);
    } catch (err) {
      console.error("Gagal fetch data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  if (loading) {
    return <AspirasiBerandaSkeleton />;
  }

  const formatRupiah = (value: number | string) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(Number(value));
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {/* TOTAL ORDER */}
      <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
        <div className="bg-blue-100 w-fit p-3 rounded-lg mb-3">
          <FaShoppingCart className="text-blue-600 text-xl" />
        </div>

        <p className="text-gray-500 text-sm">Total Order</p>
        <h2 className="text-3xl font-bold">{data.total_orders}</h2>
      </div>

      {/* TOTAL REVENUE */}
      <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
        <div className="bg-green-100 w-fit p-3 rounded-lg mb-3">
          <FaMoneyBillWave className="text-green-600 text-xl" />
        </div>

        <p className="text-gray-500 text-sm">Total Revenue</p>
        <h2 className="text-3xl font-bold">{formatRupiah(data.total_revenue)}</h2>
      </div>

      {/* TOTAL KOMISI */}
      <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
        <div className="bg-yellow-100 w-fit p-3 rounded-lg mb-3">
          <FaHandHoldingUsd className="text-yellow-600 text-xl" />
        </div>

        <p className="text-gray-500 text-sm">Total Komisi</p>
        <h2 className="text-3xl font-bold">{formatRupiah(data.total_commission)}</h2>
      </div>

      {/* AFFILIATE NAME */}
      <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
        <div className="bg-purple-100 w-fit p-3 rounded-lg mb-3">
          <FaUser className="text-purple-600 text-xl" />
        </div>

        <p className="text-gray-500 text-sm">Affiliate</p>
        <h2 className="text-xl font-bold">{data.affiliate}</h2>
      </div>
    </div>
  );
};

export default BerandaAffiliateSummary;
